import * as angular from 'angular';
import * as angularTranslate from 'angular-translate';

import { goModalBootstrapModule } from '../go-modal-bootstrap.factory';
import { confirmModalModule } from '../confirm';
import { activityModel } from '../../models/activity';
import { mediaModel } from '../../models/media';
import { ActivityRecordingInstructionsEditorModal } from './modal.instructions-recording';
import { ActivityFeedbackInstructionsEditorModal } from './modal.instructions-feedback';
import { ActivityInstructionsEditorModal } from './modal';
import type { ModalOptions as ExportModalOptions } from './options';

import './modal.less';
import { ngxInstructionsPreviewDialogModule } from '@go-modules/components/dialogs/instructions-preview';

// TODO: fix circular dependency.
// Until then, we need to import directly to force side-effect of angular module
// loading. If we leave the `fooModule from` part, webpack will use tree-shaking
// and the module will not be loaded.

import /*{ goModal } from*/ 'go-modules/modals';
import /*{ mediaThumbnailModule } from*/ '../../media-thumbnail';
import { ngxRichTextEditorModule } from '@go-modules/components/rich-text-editor';
import { ngxFeatureFlagServiceModule } from '@go-modules/services/feature-flag';

export {
	ActivityRecordingInstructionsEditorModal,
	ActivityFeedbackInstructionsEditorModal
};

export type ModalOptions = ExportModalOptions;

export const activityInstructionsEditorModalModule = angular.module('modal.activityInstructionsEditor', [
	goModalBootstrapModule,
	angularTranslate,
	confirmModalModule,
	activityModel,
	mediaModel,
	ngxInstructionsPreviewDialogModule,
	ngxRichTextEditorModule,
	ngxFeatureFlagServiceModule,
	// TODO: use module strings directly until circular dependency is fixed
	'go.modal',
	'go.mediaThumbnail'
])
	.service('activityInstructionsEditorModal', ActivityInstructionsEditorModal)
	.service('activityRecordingInstructionsEditorModal', ActivityRecordingInstructionsEditorModal)
	.service('activityFeedbackInstructionsEditorModal', ActivityFeedbackInstructionsEditorModal)
	.name;
